module.exports = "<div class=\"gw-prequal-questions\">\n    <h2 class=\"gw-page-section-title gw-as-page-title\">{{'quoteandbind.views.prequal-questions.Qualification' | translate}}</h2>\n    <ng-form class=\"ng-class:{ 'gw-submitted': form.submitted }\" name=\"form\">\n        <div data-ng-repeat=\"qs in questionSets\">\n            <div gw-pl-question-set=\"qs\"></div>\n        </div>\n\n        <div gw-wizard-page-actions next=\"next\"></div>\n    </ng-form>\n</div>"


/*****************
 ** WEBPACK FOOTER
 ** ./common/grunt/webpack/loaders/text-loader!./common/js/src/edge/quoteandbind/common/views/prequal-questions.html
 ** module id = 377
 ** module chunks = 0
 **/